<script>
	import appConfig from '@src/app.config'
	import Layout from '@layouts/_main'
	import PageHeader from '@components/page-header'

    import { deviceApi } from '@router/apiFiles/deviceApi'
	import { customerApi } from '@router/apiFiles/customerApi'
	
	/**
	 * Order Detail
	 */
	export default {
		page: {
			title: 'Create Device',
			meta: [{ name: 'description', content: appConfig.description }],
		},
		components: {
			Layout,
			PageHeader,
		},
		data() {
			return {
                items: [
                    {
                        text: 'OnBoard',
                        href: '/',
                    },
                    {
                        text: 'Devices',
                        href: '/',
                    },
                    {
                        text: 'Create',
                        active: true,
                    },
				],
                isBusy: true,
                device: {},
                lastMessages : [],
				show: false,
				planActive: null,
                confirmation: false,

				
			}
		},
        props: {
            number: {
                type: String,
                default: null
            }
		},
		computed: {
			orderIsValid() {
            },
        },
		mounted() {

			
			this.fetchData().catch(error => {
				console.error(error)
			})
		},
		methods: {
			async fetchData() {
				var self = this;
				self.isBusy = true;
				customerApi.searchCustomers({ search: '', page: 1, perPage: 50 })
					.then(function (data) {
						self.customers = data.data;
					}),
				deviceApi.searchDeviceModels({ search: '', page: 1, perPage: 50 })
					.then(function (data) {
						self.deviceModels = data.data;
						self.isBusy = false;
					});				
			},		
            save() {
				var self = this;
				self.isBusy = true;
				self.show = false;
				deviceApi.createDevice({ modemId: self.modemIdentifier, modelId: self.deviceModelId, customerId: self.customerId })
					.then(function (data) {
						self.isBusy = false;
						self.$router.push('/');
					});
			},

		}
	}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<b-overlay :show="isBusy">
			<div class="row">

				<div class="col-lg-6">
					<div class="card">
						<div class="card-body">
							<h4 class="header-title mb-3">Create Device</h4>
							
							<div class="row">
								<!-- Customer -->
								<div class="col-sm-6 col-md-4">
									<div class="form-group">
										<label>Customer</label>
										<div>
											<select class="form-control" v-model="customerId" style="max-width:100%">
												<option v-for="customer of customers" v-bind:key="customer.id" v-bind:value="customer.id">{{customer.name}}</option>
											</select>
										</div>
									</div>
								</div>
								<!-- End Customer -->
	
								<!-- Model -->
								<div class="col-sm-6 col-md-4">
									<div class="form-group">
										<label>Model</label>
										<div>
											<select class="form-control" v-model="deviceModelId" style="max-width:100%">
												<option v-for="model of deviceModels" v-bind:key="model.id" v-bind:value="model.id">{{model.name}}</option>
											</select>
										</div>
									</div>
								</div>
								<!-- End Model -->							
							</div>
							
							<div class="row">
								<div class="col-lg-6">
									<div class="mb-4">
										<h5 class="mt-0">Modem Id:</h5>
										<b-form-input v-model="modemIdentifier"></b-form-input>
									</div>
								</div>
							</div>
							
							<div class="row">
								<div class="col-lg-6">
									<a href="javascript: void(0);" @click="save()" class="btn btn-primary btn-sm float-right">Save<i class="uil uil-edit ml-1"></i></a>
								</div>
							</div>

						</div>
					</div>
				</div>
				
			</div>


		</b-overlay>
	</Layout>
</template>
